module.exports = __webpack_public_path__ + "static/angle-up.fd9a71bebff58b6f154e301164e00b3b.svg";